// extracted by mini-css-extract-plugin
export var container = "_b6-0";
export var containerTopRight = "_b6-1";